import { States } from '@truepill/tpos-types'

const states = Object.values(States).sort()

export const getStatesExcluding = (mStates: States[]): States[] => states.filter(s => !mStates.includes(s))

export default states
